import { useMemo } from 'react';
import { useApp } from '../context/AppContext';
import { todayDateStringInTz, DAY_ANCHOR_TZ } from '../utils/time';
import { parseBirthday } from '../utils/birthdays';
import { parseHireDate } from '../utils/workAnniversaries';
import { daysUntilAnnualDate, yearOfNextOccurrence } from '../utils/annualDates';

// Returns { type: 'birthday' } or { type: 'anniversary', years } if today is
// the signed-in user's own birthday or work anniversary, else null. Same
// underlying date math as AnnouncementBanner's self-today check, kept
// separate rather than shared code since the banner needs the full
// everyone-else rotation list and this only ever needs a single yes/no for
// the current viewer (used by CelebrationPopup).
export default function useSelfCelebration() {
  const { currentUser } = useApp();

  return useMemo(() => {
    if (!currentUser) return null;
    const today = todayDateStringInTz(DAY_ANCHOR_TZ);

    const bday = parseBirthday(currentUser.birthday);
    if (bday && daysUntilAnnualDate(bday.month, bday.day, today) === 0) {
      return { type: 'birthday' };
    }

    const hire = parseHireDate(currentUser.date_of_hire);
    if (hire) {
      const daysUntil = daysUntilAnnualDate(hire.month, hire.day, today);
      const years = yearOfNextOccurrence(hire.month, hire.day, today) - hire.year;
      if (daysUntil === 0 && years >= 1) {
        return { type: 'anniversary', years };
      }
    }

    return null;
  }, [currentUser]);
}
